import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";
import "./Contact.css";

function Contact() {
  const form = useRef();
  const [verified, setVerified] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    if (!verified) {
      alert("กรุณายืนยันว่าไม่ใช่บอทก่อนส่งข้อความ");
      return;
    }

    emailjs
      .sendForm(
        "service_2cjiktr",           // 🔁 เปลี่ยนเป็นของคุณ
        "template_ncwduvr",         // 🔁 เปลี่ยนเป็นของคุณ
        form.current,
        "6Yn8mULEpQHiQLPIT"         // 🔁 เปลี่ยนเป็นของคุณ
      )
      .then(
        () => {
          alert("ส่งข้อความสำเร็จแล้ว!");
          form.current.reset();
          setVerified(false); // รีเซ็ตสถานะหลังส่ง
        },
        (error) => {
          alert("เกิดข้อผิดพลาด: " + error.text);
        }
      );
  };

  return (
    <div className="contact-wrapper">
      <div className="container mt-5">
        <h2 className="text-center mb-4">ติดต่อเรา</h2>
        <div className="row align-items-start justify-content-center">

          {/* ฟอร์ม */}
          <div className="col-md-7">
            <form ref={form} onSubmit={sendEmail}>
              <div className="mb-3">
                <label>ชื่อ</label>
                <input type="text" name="name" className="form-control" required />
              </div>
              <div className="mb-3">
                <label>อีเมล</label>
                <input type="email" name="email" className="form-control" required />
              </div>
              <div className="mb-3">
                <label>หัวข้อ</label>
                <input type="text" name="title" className="form-control" required />
              </div>
              <div className="mb-3">
                <label>ข้อความ</label>
                <textarea name="message" className="form-control" rows="5" required></textarea>
              </div>

              {/* ✅ reCAPTCHA */}
              <div className="mb-3">
                <ReCAPTCHA
                  sitekey="6LdjZkIrAAAAALHtnG7B4MavoAdgCwPQagtm93g5" // 🔁 ใส่ Site Key ที่ได้จาก Google
                  onChange={() => setVerified(true)}
                  onExpired={() => setVerified(false)}
                />
              </div>

              <button type="submit" className="btn btn-primary" disabled={!verified}>
                ส่งข้อความ
              </button>
            </form>
          </div>

          {/* LINE image */}
          <div className="col-md-4 text-center mt-4 mt-md-0">
            <p className="mb-3">สอบถามผ่าน LINE</p>
            <a href="https://page.line.me/708otesw" target="_blank" rel="noopener noreferrer">
              <img
                src="/010525683.png"
                alt="LINE"
                style={{ width: "120px", cursor: "pointer" }}
              />
            </a>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Contact;
